import { render, staticRenderFns } from "./PlaceholderTable.vue?vue&type=template&id=19b020da&scoped=true&"
import script from "./PlaceholderTable.vue?vue&type=script&lang=js&"
export * from "./PlaceholderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b020da",
  null
  
)

export default component.exports